import { getLocalDateString } from "./dateUtils";
import { DEFAULT_DISPLAY_CURRENCY } from "../constants/currency";
import { formatMoney } from "./currency";

/**
 * Format a number as money in the requested display currency.
 * @param {number|string} value - The value to format
 * @returns {string} Formatted currency string
 */
export const fmt = (v, currency = DEFAULT_DISPLAY_CURRENCY, options = {}) =>
  formatMoney(parseFloat(v), currency, options);

/**
 * Format an ISO date string to Portuguese locale with time
 * @param {string} iso - ISO date string
 * @returns {string} Formatted date string (DD/MM/YYYY HH:MM)
 */
export const fmtDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Convert ISO date to YYYY-MM-DD string (for input[type="date"])
 * @param {string} iso - ISO date string
 * @returns {string} YYYY-MM-DD format
 */
export const toDateStr = (iso) => {
  if (!iso) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(iso))) return String(iso);
  return getLocalDateString(iso);
};
